import { render, staticRenderFns } from "./AuthHeader.vue?vue&type=template&id=5481e714"
import script from "./AuthHeader.vue?vue&type=script&lang=js"
export * from "./AuthHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports